import { render, staticRenderFns } from "./RegInputText.vue?vue&type=template&id=6d666cc8"
import script from "./RegInputText.vue?vue&type=script&lang=js"
export * from "./RegInputText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports